module.exports = "/assets/data/b4e7cc5f63e99c1db04afde9d0258184-NR17.data.json";